import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {usePage} from "@inertiajs/inertia-react";
import Helper from "../application/helper";
import {Inertia} from '@inertiajs/inertia'
import axios from "axios";
import {CButton, CButtonGroup, CCol, CContainer, CFormFloating, CFormInput, CFormLabel, CRow} from "@coreui/react";
import Pagination from "./Pagination";
import {useDispatch, useSelector} from "react-redux";
import {operate} from "../store/slice/component/table";
import exportFromJSON from 'export-from-json'

const Table = forwardRef((props, ref) => {
    let p = JSON.parse(JSON.stringify(usePage()));
    const [current_route_name, set_current_route_name] = useState(p.props.current_route_name);
    useImperativeHandle(ref, () => ({
            callFromSubmitted(data) {
                fromSubmitted(data)
            },
            callExportData(data) {
                exportData(data)
            },
            getState: () => {
                return current_route_name
            }
        }
    ));

    const dispatch = useDispatch([]);
    const [propsD, setPropsD] = useState(Object.assign({}, p.props));
    const [mounted, setMounted] = useState(false);
    const list = useSelector(state => state.entities.component_table);
    const auth = useSelector(state => state.entities.auth);

    useEffect(() => {
        if (mounted === false) {
            setMounted(true);
            afterComponentDidMount();
        }
    });

    const setCRN = () => {
        set_current_route_name(current_route_name.replace('.index', ''));
    }

    const exportData = () => {
        let apiR = current_route_name.replace('.index', '');
        apiR = apiR.replaceAll('-', '');
        apiR = Helper.route(apiR + '.index');
        if (list.total) {
            axios.get(apiR, {records_per_page: list.total}).then((res) => {
                if (res.data.data !== undefined && res.data.data.length) {
                    const fileName = current_route_name
                    const exportType = exportFromJSON.types.xls
                    const data = res.data.data
                    exportFromJSON({data, fileName, exportType})
                }
            });
        }
    }

    const afterComponentDidMount = () => {
        setCRN()
        setSystemData();
    }

    const setSystemData = () => {
        if (
            propsD.current_page !== undefined &&
            propsD.current_page !== 1 &&
            (propsD.data !== undefined && !propsD.data.length)
        ) {
            let propsDT = Object.assign({}, propsD);
            propsDT.page = 1;
            propsDT.current_page = 1;
            reloadPage(propsDT);
            dispatch(operate(propsDT));
        } else {
            dispatch(operate(p.props));
        }
    }
    const getData = (paginationData) => {
        paginationData.current_page = paginationData.page;
        let pT = Object.assign(p.props, paginationData);
        reloadPage(pT);
    }

    const fromSubmitted = (data) => {
        data = Object.assign({}, data);
        data.page = p.props.current_page;
        reloadPage(data);
    }

    const reloadPage = (data) => {
        let here = Object.assign({}, data);
        if (data.current_page !== undefined)
            here.page = here.current_page;
        delete here.current_page;
        delete here.current_route_name;
        delete here.data;
        delete here.errors;
        delete here.first_page_url;
        delete here.from;
        delete here.last_page;
        delete here.last_page_url;
        delete here.links;
        delete here.next_page_url;
        delete here.path;
        delete here.per_page;
        delete here.prev_page_url;
        delete here.to;
        delete here.total;
        Inertia.get(Helper.route(current_route_name.replace('.index', '') + '.index'), here)
    }

    return <>
        <CContainer fluid={true}>
            <CRow>
                <CCol>
                    {props.children}
                    {list.current_page !== undefined &&
                    <>
                        <CRow className={'mt-3 float-start'}>
                            <CCol>
                                <CFormFloating className="mb-3">
                                    <CFormInput type="text"
                                                autoFocus
                                                onChange={(e) => {
                                                    setTimeout(() => {
                                                        getData({
                                                            page: e.target.value
                                                        })
                                                    }, 200);
                                                }}
                                                defaultValue={list['current_page'] || ""}
                                    />
                                    <CFormLabel htmlFor="floatingInput">Page</CFormLabel>
                                </CFormFloating>
                            </CCol>
                        </CRow>
                        <CRow className={'mt-3 float-end'}>
                            <CCol>
                                <Pagination changePage={getData} data={list}/>
                            </CCol>
                        </CRow>
                    </>
                    }
                </CCol>
            </CRow>
            <CRow className={'mt-3'}>
                <CCol md={3}>
                    <CButtonGroup
                        className={'p-1'} size={'sm'}
                        role="group" aria-label="Basic mixed styles example">
                        {auth.is_admin &&
                        <>
                            {list.data !== undefined && list.data[0] !== undefined &&
                            <>
                                <CButton size={'sm'} color={'warning'} onClick={() => {
                                    exportData()
                                }}>Raw Export to Excel</CButton>
                            </>
                            }
                        </>
                        }
                        <CButton size={'sm'} color={'info'} onClick={() => {
                            Inertia.get(Helper.route(current_route_name.replace('.index', '') + '.index'))
                        }}>Reload</CButton>
                    </CButtonGroup>
                </CCol>
            </CRow>
        </CContainer>
    </>;
});

export default Table;
